import { motion } from 'framer-motion'
import { Rocket, Rabbit, Info, Tag } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'

const sections = [
  {
    id: 'products',
    icon: Rabbit,
    label: 'Go',
    color: 'from-sky-400 to-teal-400',
    description: 'Participate in DeFi launched by the Community'
  },
  {
    id: 'create',
    icon: Rocket,
    label: 'Create',
    color: 'from-amber-400 to-orange-400',
    description: 'Create Your Own DeFi Products'
  }
]

export function LandingPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex flex-col">
      {/* Stained glass background pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_10%,_rgba(16,185,129,0.3)_0%,_transparent_50%),radial-gradient(circle_at_80%_20%,_rgba(59,130,246,0.3)_0%,_transparent_50%),radial-gradient(circle_at_40%_40%,_rgba(234,179,8,0.3)_0%,_transparent_50%)]"></div>
      <header className="py-8 text-center">
        <div className="flex items-center justify-center gap-1 mb-2">
          <span className="brand-symbol text-4xl text-secondary">†</span>
          <h1 className="brand-title text-2xl">
            <span className="bg-gradient-to-r from-emerald-400 to-emerald-600 bg-clip-text text-transparent">RINITY</span>
          </h1>
        </div>
      </header>

      <main className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4 p-4 md:p-8">
        {sections.map((section) => (
          <motion.button
            key={section.id}
            onClick={() => navigate(`/${section.id}`)}
            className={`relative overflow-hidden rounded-2xl p-8 flex flex-col items-center justify-center text-white
              bg-gradient-to-br ${section.color} hover:opacity-90 transition-opacity`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <section.icon size={48} weight="bold" />
            <h2 className="mt-4 text-xl font-semibold">{section.label}</h2>
            <p className="mt-2 text-sm opacity-80">{section.description}</p>
          </motion.button>
        ))}
      </main>
    </div>
  )
} 